<div class="d-flex justify-content-center no-data-box-wrapper">
  <img
    class="no-data-icon"
    alt="no data indicator"
    src="../../../assets/icons/no-data.svg"
  />
</div>

